import React, { useEffect } from 'react'
import Image from '../../../components/common/Image'

const Advertisement = ({ data, onClose, onConfirm }) => {
    console.log(data)
    const { ad, station } = data
    return (
        <div className='modal page-modal'>
            <div className='block'>
                <div className='container'>
                    <div className="page-header">
                        <button className="btn-circle" onClick={onClose}>
                            <Image src="/images/icons/close.svg" svg />
                        </button>
                        <div className="page_header__title">
                            <h1 className="font-heading">{ad.title}</h1>
                            <p className="text-secondary text-scale-02">
                                {ad.summary}
                            </p>
                        </div>
                    </div>
                    <div className='content-block'>
                        <div className='ad-block'>
                            <figure>
                                <img src={ad.picPath} alt={ad.summary} />
                            </figure>
                            <div className='ad-block__list'>
                                <div className='title'>活動說明</div>
                                <div className='desc'>{ad.description}</div>
                            </div>
                            <div className='ad-block__list'>
                                <div className='title'>活動規則</div>
                                <ul className='desc'>
                                    {
                                        console.log()
                                    }

                                    {
                                        ad.rules.indexOf('\r\n') > -1 ? 
                                        ad.rules.split('\r\n').map(a => (<li key={a}>{a}</li>)) :
                                        <li>{ad.rules}</li>
                                    }
                                </ul>
                            </div>
                            <div className='station-block'>
                                <p className='text'>離起點 {station.distance} 公里</p>
                                <p className='title font-heading'>Toyota 內湖服務廠</p>
                                <p className='text'>114台北市內湖區內湖路一段91巷34號</p>
                                <button className='btn' onClick={onConfirm}>
                                拖吊到這裡 
                                </button>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    )
}

export default Advertisement